import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getRazorPayTransactionListV1 } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class paymentsLinks extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              paymentLinkList: [],
        };

        this.getList();
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_school', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });


    }


    getList = () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        location: this.state.location
      });
      getRazorPayTransactionListV1(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            paymentLinkList: res.user_list
            
          });
        } else {
          this.setState({
            paymentLinkList: [],
          });
        }
      });
    }    

    render() {

        const { paymentLinkList } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Razorpay PaymentLinks</h4>
                 
                  <div class="table-responsive pt-3">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>
                            <strong>S.No</strong>
                          </th>
                          <th>
                            <strong>Date</strong>
                          </th>
                          
                          <th>
                            <strong>Payment ID</strong>
                          </th>
                          <th>
                            <strong>Partner name</strong>
                          </th>

                          <th>
                            <strong>Type</strong>
                          </th>

                          <th>
                            <strong>Package Chosen</strong>
                          </th>
                           <th>
                            <strong>Amount</strong>
                          </th>

                          <th>
                            <strong>Status</strong>
                          </th>
                          <th>
                            <strong>Action</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {paymentLinkList.map((item, i) => {     
                      
                       return <tr>
                          <td>
                            {i+1}
                          </td>
                          <td>
                           {item.transaction_date}
                          </td>
                          
                          <td>
                           {item.razorpay_payment_id}
                          </td>
                          <td>
                            {item.name}
                          </td>
                          <td>
                            {item.user_type}
                          </td>
                          <td>
                            {item.plan_id}
                          </td>
                          <td>
                            {item.amount}
                          </td>

                          <td dangerouslySetInnerHTML={{__html: item.status}} />
                                                     
                          <td dangerouslySetInnerHTML={{__html: item.action}} />

                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default paymentsLinks;


// WEBPACK FOOTER //
// ./src/components/bewise/paymentlinks.jsx